// src/app/http/api-prefix.interceptor.ts
import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const originalUrl = req.url;
    // Leave absolute URLs alone
    if (/^https?:\/\//i.test(originalUrl)) {
      return next.handle(req);
    }

    let newUrl = originalUrl;
    if(newUrl.startsWith('/api/') || newUrl.startsWith('/login') || newUrl.startsWith('/admin')) {
      console.log('trimming leading slash');
      newUrl = newUrl.substring(1);
    }

    if (!newUrl.startsWith('api/') && !newUrl.startsWith('login') && !newUrl.startsWith('admin')) {
      return next.handle(req);
    }

    // document.baseURI respects <base href="..."> and is always absolute
    const base = document.baseURI.endsWith('/') ? document.baseURI : document.baseURI + '/';
    newUrl = new URL(newUrl, base).toString(); // -> https://host/app/api/...

    return next.handle(req.clone({ url: newUrl }));
  }
}
